<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  .el-cascader-panel {
  height: 300px !important;
}
</style>
